import { create } from 'zustand'
import { localStore } from '../lib/platform'

const STORAGE_KEY = 'boss-chat.gesture-tip-seen.v1'

export function loadGestureTipSeen(storage: Pick<Storage, 'getItem'> | undefined = localStore()): boolean {
  try {
    return storage?.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

function saveSeen(): void {
  try {
    localStore()?.setItem(STORAGE_KEY, '1')
  } catch {
    // Storage unavailable: the tip can show once more next time the app starts.
  }
}

interface GestureTipState {
  /** Shown once on this device, or a swipe or hold already used: it is not shown again. */
  seen: boolean
  /** A swipe or hold was used: a tip still showing can go. */
  used: boolean
  markSeen: () => void
  markUsed: () => void
}

/** The one-time tip on phones: swipe a message right to reply, or hold it for more (spec D10). */
export const useGestureTip = create<GestureTipState>((set, get) => ({
  seen: loadGestureTipSeen(),
  used: false,
  markSeen: () => {
    if (get().seen) return
    saveSeen()
    set({ seen: true })
  },
  markUsed: () => {
    if (!get().seen) saveSeen()
    set({ seen: true, used: true })
  },
}))
